import { SBUBUMapModel } from "../models/SBUBUMapModel";
import { client } from "./API";

const SBUBUMapService = {
  async getSBUBUMaps() {
    const response = await client({
      url: "SBU/GetSBUBUMapping",
      method: "get",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async createSBUBUMap(
    data: SBUBUMapModel
  ) {
    try {
      const response = await client({
        method: "post",
        url: "SBU/PostSBUBUMapping",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  async deleteSBUBUMap(
    data: SBUBUMapModel
  ) {
    try {
      const response = await client({
        method: "delete",
        url: "SBU/DeleteSBUBUMapping",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
};
export default SBUBUMapService;
